import { render, staticRenderFns } from "./MarkingStatusBadge.vue?vue&type=template&id=1d7c00fc&scoped=true"
import script from "./MarkingStatusBadge.vue?vue&type=script&lang=js"
export * from "./MarkingStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./MarkingStatusBadge.vue?vue&type=style&index=0&id=1d7c00fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7c00fc",
  null
  
)

export default component.exports